import React from "react";
import AppLayout from "@/components/AppLayout";
import TutorPanel from "@/components/TutorPanel";

export default function TutorPage() {
  return (
    <AppLayout>
      <div className="max-w-3xl mx-auto px-6 py-6" data-testid="tutor-page">
        <div className="mb-4">
          <div className="overline mb-2">AI Compliance Tutor</div>
          <h1 className="font-serif text-3xl text-[var(--dw-navy)] tracking-tight">Ask anything. Cite everything.</h1>
        </div>
        <TutorPanel />
      </div>
    </AppLayout>
  );
}
